module.exports = __webpack_public_path__ + "static/Jen_new-3420c6633f3d8eab3fd6d437a273d79c.png";